import $http from '@vue-util/http';

const isLockedOut = (errors) => {
  if (!errors) return false;
  const err = errors.find((e) => e.errorCode === '20003');
  return !!err;
};

export const useGiftCardBalanceStore = defineStore('giftCardBalance', {
  state: () => ({
    form: {
      cardNumber: '',
      cardNumberMasked: '',
      cardNumberEncrypted: '',
      cid: '',
    },
    balance: '',
    lockout: false,
    loadingBalance: false,
    notifications: [],
  }),
  actions: {
    setGiftCardForm(payload) {
      if (!payload) {
        this.form = {
          cardNumber: '',
          cardNumberMasked: '',
          cardNumberEncrypted: '',
          cid: '',
        };
        return;
      }
      this.form = payload;
    },
    setGiftCardBalance(payload = '') {
      this.balance = payload;
    },
    setGiftCardNotification(payload = []) {
      if (!payload.length) {
        this.notifications = [];
        return;
      }
      this.notifications = payload;
    },
    setLoading(loadingBalance = false) {
      this.loadingBalance = loadingBalance;
    },
    async saveGiftCardForm(form) {
      try {
        this.setLoading(true);
        const response = await $http.post('/account-xapi/api/giftcardbalance', form);
        this.lockout = false;
        this.setGiftCardNotification();
        this.setGiftCardForm(response.data.giftCard);
        this.setGiftCardBalance(response.data.giftCard.cardBalance);
        return {
          success: true,
          balance: response.data.giftCard.cardBalance,
        };
      } catch (e) {
        this.balance = '';
        const err = e?.response?.data;
        this.lockout = isLockedOut(err?.errors);
        this.setGiftCardForm(err?.giftCard);
        this.setGiftCardNotification(err?.errors);
        return { errors: err?.errors };
      } finally {
        this.setLoading(false);
      }
    },
    async setLockoutMode(payload) {
      this.lockout = payload;
      const lockout = [
        {
          message:
            "The Card Number or CID number you entered is invalid. You've reached the maximum number of attempts to check your gift card balance. Please contact Customer Service at 1-800-511-2752 for help.",
        },
      ];
      const lockoutMessage = payload ? lockout : [];
      if (payload) {
        this.setGiftCardForm();
        this.setGiftCardBalance();
      }
      this.setGiftCardNotification(lockoutMessage);
    },
  },
});
